import { cn } from '@/service/utils/cn';
import Link from 'next/link';

type TBreadcrumbsProps = {
    items: { label: string; path: string; highlight?: boolean; onClick?: () => void }[];
    className?: string;
};

export const BreadCrumbs = ({ items, className }: TBreadcrumbsProps) => (
    <nav className={cn('tx-large-medium mt-6 w-full md:mt-7', className)}>
        <ol className="list-reset flex">
            {items.map(({ path, label, highlight, onClick }, i) => {
                const isLastItem = i === items.length - 1;

                return (
                    <li key={label}>
                        {isLastItem ? (
                            <span
                                className={`${
                                    highlight ? 'text-brand' : 'text-gray-1 dark:text-white'
                                }`}
                            >
                                {label}
                            </span>
                        ) : (
                            <>
                                <Link
                                    href={path}
                                    className="text-gray-3 hover:text-gray-1 dark:hover:text-white"
                                    prefetch={false}
                                    onClick={onClick}
                                >
                                    {label}
                                </Link>
                                <span className="mx-2 text-gray-3">/</span>
                            </>
                        )}
                    </li>
                );
            })}
        </ol>
    </nav>
);
